import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import axios from 'axios';
import JoditEditor from "jodit-react";
import { Modal, Button } from "react-bootstrap";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ContactUpdate = () => {
  const navigate = useNavigate();
    const { srno } = useParams();
    const editor = useRef(null);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
      srno: "",
      name: "",
      email: "",
      subject: "",
      message: "",
      responseStatus: "Pending",
      responseMessage: "",
      responseNextStep: "",
      responseNextPerson: "",
      finalStatus: 0,
    });
  
    useEffect(() => {
    const fetchDetails = async () => {
      try {
        const headers = { "x-access-token": localStorage.getItem("jwttoken") };
        const response = await axios.get(`${process.env.REACT_APP_API_URL}contact/alluser`, { headers });
        const data = response.data.find(x => x.srno === parseInt(srno));
        if (data) setFormData(data);
      } catch (error) {
        toast.error(
          error.response?.data?.message ||
          "Failed to load details",
          {
            position: "top-right",
            autoClose: 1000,
            theme: "colored",
          }
        );
      }
    };
    fetchDetails();
  }, [srno]);

   const handleChange = (e) => {
        const { name, value } = e.target;
        const val = name === "finalStatus" ? parseInt(value) : value; 
        setFormData((prev) => ({ ...prev, [name]: val }));
    };
    const handleEditorChange = (newContent) => {
        setFormData((prev) => ({ ...prev, responseMessage: newContent }));
    };

    const handleUpdate = async () => {
      setShowConfirmModal(false);
      const loadingToast = formData.responseStatus === "Responded" 
            ? toast.info("Updating and sending email...", { autoClose: false }) 
            : null;
     try {
      setLoading(true);
      const headers = { "x-access-token": localStorage.getItem("jwttoken") };
      await axios.put(`${process.env.REACT_APP_API_URL}contact/updatecontact`, formData, { headers });
      
      if (loadingToast) toast.dismiss(loadingToast);

      toast.success("Contact Updated Successfully", {
        theme: "colored",
        position: "top-right",
        autoClose: 2000
      });

      setTimeout(() => navigate("/contact"), 2000);
    } catch (error) {
      if (loadingToast) toast.dismiss(loadingToast);

      toast.error(
        error.response?.data?.message ||
        "Update failed",
        {
          position: "top-right",
          autoClose: 1000,
          theme: "colored",
        }
      );

      throw error;
    } finally {
      setLoading(false);
    }
  };
    
    return (
     <div className="container mt-4">
      <div className="form-card border rounded shadow-sm bg-white">
        <div className="form-card-header bg-info text-white p-3 fw-bold">Update Contact Response</div>
        <div className="form-card-body p-4">
          <form onSubmit={(e) => { e.preventDefault(); setShowConfirmModal(true); }}>
            
            <h5 className="mb-3 text-primary">User Inquiry Details</h5>
            <div className="row mb-3">
              <div className="col-md-4">
                <label className="form-label small fw-bold">Name</label>
                <input type="text" name="name" className="form-control bg-light" value={formData.name}  onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label className="form-label small fw-bold">Email</label>
               <input type="text" name="email" className="form-control bg-light" value={formData.email}  onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label className="form-label small fw-bold">Subject</label>
                <input type="text" name="subject" className="form-control bg-light" value={formData.subject}  onChange={handleChange} />
              </div>
            </div>
            
            <div className="mb-4">
  <label className="form-label small fw-bold">User Message</label>
  <textarea 
    name="message" 
    className="form-control bg-light" 
    rows="2" 
    value={formData.message}  
    onChange={handleChange}
  ></textarea>
</div>

            <hr className="my-4" />
            <h5 className="mb-3 text-success">Admin Response</h5>
            
            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label small">Response Status</label>
                <select name="responseStatus" className="form-select" value={formData.responseStatus} onChange={handleChange}>
                  <option value="Pending">Pending</option>
                  <option value="In Progress">In Progress</option>
                  <option value="Responded">Responded</option>
                </select>
              </div>
              <div className="col-md-6">
                <label className="form-label small">Final Status (1=Resolved, 0=Open)</label>
                <input type="number" name="finalStatus" className="form-control" value={formData.finalStatus} onChange={handleChange} />
              </div>
            </div>

            <div className="mb-3">
              <label htmlFor="responseMessage" className="form-label small fw-bold">Response Message:</label>
              <JoditEditor
                ref={editor}
                value={formData.responseMessage}
                tabIndex={1}
                onBlur={handleEditorChange}
                onChange={(newContent) => {}} 
                className="form-control"
              />
            </div>

            <div className="row mb-4">
              <div className="col-md-6">
                <label className="form-label small">Next Step</label>
                <input type="text" name="responseNextStep" className="form-control" value={formData.responseNextStep} onChange={handleChange} />
              </div>
              <div className="col-md-6">
                <label className="form-label small">Assign To (Next Person)</label>
                <input type="text" name="responseNextPerson" className="form-control" value={formData.responseNextPerson} onChange={handleChange} />
              </div>
            </div>

            <div className="form-actions">
              <button type="submit" className="btn-gradient-primary">
                Update Inquiry
              </button>
              <Link to="/Contact" className="btn-back-link">
                ← Back to List
              </Link>
            </div>
          </form>
        </div>
      </div>

      <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Update</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to update this contact inquiry?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowConfirmModal(false)}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleUpdate}
            disabled={loading}
          >
            {loading ? "Updating..." : "Update"}
          </Button>
        </Modal.Footer>
      </Modal>
      <ToastContainer />
    </div>
  );
}
export default ContactUpdate
